import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  airports: Array<App.Airport>
  selectedAirport?: App.Airport
}

function FlightDealAirportSelectModal(props: Props) {
  const { airports, selectedAirport } = props
  const intl = useIntl()

  const context = useModalElementContext<App.Airport>()

  return <Modal title={intl.formatMessage({
    id: 'MjnN33vjTJ',
    defaultMessage: 'Departing from',
    description: 'Heading title for airport selection modal in the flights section',
  })}
  >
    {airports.map((airport) =>
      <ClickableListItem
        key={airport.code}
        size="medium"
        selected={selectedAirport?.code === airport.code}
        title={airport.name}
        data-code={airport.code}
        onClick={() => context.resolve(airport)}
      />,
    )}
  </Modal>
}

export default FlightDealAirportSelectModal
